@if (panelS.isOpen()) {
    <aside
        class="fixed inset-y-0 right-0 z-[60] flex w-full max-w-[420px] flex-col border-l border-zinc-200/80 bg-twMainBackground shadow-[-12px_0_40px_-12px_rgba(24,24,27,0.18)] animate-[slideInRight]">
        <!-- Panel chrome -->
        <header class="flex shrink-0 items-center gap-2.5 border-b border-zinc-200/70 bg-white px-4 py-3">
            <span
                class="flex size-8 items-center justify-center rounded-xl bg-zinc-900 text-white">
                <lucide-icon [img]="SparklesIcon" [size]="16" [strokeWidth]="1.75" />
            </span>
            <div class="flex flex-col">
                <span class="text-[13.5px] font-semibold tracking-[-0.005em] text-twTextPrimary">
                    {{ T.title | translate }}
                </span>
                <span class="text-[11px] text-zinc-500">{{ T.subtitle | translate }}</span>
            </div>

            <div class="ml-auto flex items-center gap-1">
                <button
                    class="tw-icon-btn"
                    type="button"
                    [title]="T.settings.open | translate"
                    (click)="settingsS.open()">
                    <lucide-icon [img]="SettingsIcon" [size]="16" [strokeWidth]="1.75" />
                </button>
                <button
                    class="tw-icon-btn"
                    type="button"
                    [title]="T.header.openFull | translate"
                    (click)="openFullView()">
                    <lucide-icon [img]="ExpandIcon" [size]="16" [strokeWidth]="1.75" />
                </button>
                <button
                    class="tw-icon-btn"
                    type="button"
                    [title]="T.header.close | translate"
                    (click)="panelS.close()">
                    <lucide-icon [img]="CloseIcon" [size]="18" [strokeWidth]="1.75" />
                </button>
            </div>
        </header>

        <app-agent-chat-thread class="min-h-0 flex-1" variant="panel" />
    </aside>
}
